import React, { useState, useEffect } from "react";
import axios from "axios";
import { Lock, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getAdminToken() {
  return localStorage.getItem("admin_token") || "";
}

export function applyAuthHeader() {
  const token = getAdminToken();
  if (token) axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

applyAuthHeader();

export function AuthGate({ children }) {
  const [state, setState] = useState("checking");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = getAdminToken();
    if (!token) { setState("locked"); return; }
    applyAuthHeader();
    axios.get(`${API}/auth/me`)
      .then(() => setState("authed"))
      .catch(() => { localStorage.removeItem("admin_token"); setState("locked"); });
  }, []);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await axios.post(`${API}/auth/login`, { password });
      localStorage.setItem("admin_token", res.data.token);
      applyAuthHeader();
      setState("authed");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  if (state === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="w-8 h-8 text-emerald-500 animate-spin" />
      </div>
    );
  }

  if (state === "locked") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0f172a] to-[#1e3a5f] px-4">
        <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-sm">
          <div className="w-14 h-14 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="w-7 h-7 text-emerald-600" />
          </div>
          <h1 className="text-xl font-bold text-[#0f172a] text-center mb-1">Espace privé</h1>
          <p className="text-gray-500 text-sm text-center mb-6">Réservé au propriétaire du site</p>
          <form onSubmit={login} className="space-y-4">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mot de passe"
              autoFocus
              data-testid="auth-password-input"
              className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100 outline-none"
            />
            {error && <p className="text-red-500 text-sm" data-testid="auth-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="auth-submit-btn"
              className="w-full bg-emerald-500 text-white py-3 rounded-xl font-bold hover:bg-emerald-600 transition-colors disabled:opacity-60">
              {loading ? "Vérification..." : "Entrer"}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return children;
}
